import styled from "styled-components";

import { ItemIcon } from "@similarweb/ui-components";

export const StyledItemIcon = styled(ItemIcon)`
    display: flex;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    border-color: #d6dbe1;
`;
